import { Appointment, AppointmentSearchResponse } from "../types/appointment.definition";
import { Order, Query } from "../types/search.definition";
import { searchApi } from "./search.api";

/** The API refuses more than 100 results per page. */
const PAGE_SIZE = 100;
/** Stops a runaway loop if the total ever comes back wrong (10 000 appointments). */
const MAX_PAGES = 100;

export type AppointmentExportQuery = Query & {
  status?: string;
  appointmentType?: string;
  date?: string;
};

/**
 * MED-1687: every appointment of the facility matching the list filters, page after page, for
 * the CSV export (the list only holds the page on screen).
 */
export async function fetchAllFacilityAppointments(
  facilityId: number,
  query: AppointmentExportQuery,
): Promise<Appointment[]> {
  const all: Appointment[] = [];
  for (let page = 0; page < MAX_PAGES; page++) {
    const response: AppointmentSearchResponse = await searchApi.searchAppointmentsInFacility(
      {
        sortBy: { property: "appointmentTime", order: Order.DESC },
        query,
        paginationSettings: { limit: PAGE_SIZE, offset: page * PAGE_SIZE },
      },
      facilityId,
    );
    const data = response.data || [];
    all.push(...data);
    const total = response.paginationSettings?.totalCount ?? all.length;
    if (data.length < PAGE_SIZE || all.length >= total) break;
  }
  return all;
}
